import { render, staticRenderFns } from "./SpecificArtist.vue?vue&type=template&id=3fc16238&scoped=true&"
import script from "./SpecificArtist.vue?vue&type=script&lang=js&"
export * from "./SpecificArtist.vue?vue&type=script&lang=js&"
import style0 from "./SpecificArtist.vue?vue&type=style&index=0&id=3fc16238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc16238",
  null
  
)

export default component.exports